import { Box } from "@mui/material";
import { DotLegalDatePicker, DotLegalDialog, DotLegalSelect, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { useRiskObservationDialogDataMapping } from "./RiskObservationDialog.hooks";
import { RiskObservationSaveModel } from "./RiskObservationDialog.types";

export interface IRiskObservationDialog {
    onCloseDialog: () => void;
    onSave: () => void;
    selectedObservation?: RiskObservationSaveModel;
}

function RiskObservationDialog(props: IRiskObservationDialog) {
    const { translateString, getDateTimePickerLanguage } = useTranslation();
    const { viewModel, validation, inProgress, isEdit, setName, setDescription, setSource, setObservedBy, setObservedDate, sourceOptions, validateAndSave } =
        useRiskObservationDialogDataMapping(props);

    return (
        <DotLegalDialog
            inProgress={inProgress}
            size="sm"
            buttonOkText={isEdit() ? translateString("save") : translateString("create")}
            header={isEdit() ? translateString("editObservation") : translateString("createObservation")}
            onOkClick={validateAndSave}
            onDialogClose={props.onCloseDialog}
            open
            disableBackdropOnCloseIfValueChange={viewModel}
        >
            <Box sx={{ marginRight: 3 }}>
                <DotLegalTextField
                    debounce={false}
                    size="small"
                    label={translateString("observation")}
                    value={viewModel.name}
                    onChange={setName}
                    errorText={validation.getErrorsForDisplay("name")}
                />
                <DotLegalTextField
                    debounce={false}
                    size="small"
                    multiline
                    rows={4}
                    label={translateString("description")}
                    value={viewModel.description ?? ""}
                    onChange={setDescription}
                />
                <DotLegalSelect
                    label={translateString("source")}
                    options={sourceOptions}
                    selectedItem={viewModel.source.toString()}
                    onChange={setSource}
                    disableClearable
                    disableSearch
                    noOptionsLabel={translateString("noOptions")}
                />
                <DotLegalTextField
                    debounce={false}
                    size="small"
                    label={translateString("observedBy")}
                    value={viewModel.observedBy ?? ""}
                    onChange={setObservedBy}
                    errorText={validation.getErrorsForDisplay("observedBy")}
                />
                <DotLegalDatePicker
                    label={translateString("observedDate")}
                    value={viewModel.observedDate}
                    onChange={setObservedDate}
                    language={getDateTimePickerLanguage()}
                    error={!!validation.getErrorsForDisplay("observedDate")}
                    helperMessage={validation.getErrorsForDisplay("observedDate")}
                />
            </Box>
        </DotLegalDialog>
    );
}

export default RiskObservationDialog;
